import angular from 'angular';
import tasksPage from './tasksPage';

export default angular
  .module('components.tasksPage', [])
  .component('tasksPage', tasksPage).name;
